<template>
  <div class="box">
    <!-- <van-image :src="banner" class="banner" /> -->
    <img :src="banner" class="banner" />
    <div v-if="!hasRecord" class="step-card">
      <div class="step-title">
        简单
        <span>3</span>
        步完成签约
      </div>
      <van-image :src="fpSteps" class="steps-info" />
      <van-button ref="targetEl" type="primary" @click="goAddRecord">立即建档</van-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import fpSteps from '@/assets/images/fp-steps.png';
import { useElementVisibility } from '@vueuse/core';
import { goAddRecord } from './common';

interface BannerProps {
  banner?: string;
  hasRecord?: boolean; // 是否有建档
}

const props = withDefaults(defineProps<BannerProps>(), {
  banner: '',
  hasRecord: false,
});

const emit = defineEmits(['watchTargetIsVisible']);

const targetEl = ref(null);
const targetIsVisible = useElementVisibility(targetEl, { scrollTarget: document.getElementById('app') });

watch(
  targetIsVisible,
  (val) => {
    emit('watchTargetIsVisible', targetIsVisible);
  },
  {
    immediate: true,
  },
);
</script>

<style lang="less" scoped>
.box {
  position: relative;
  flex-direction: column;

  .banner {
    width: 750px;
    height: 401px;
  }

  .step-card {
    margin: 20px 24px;
    border-radius: 16px;
    background: #fff;
    box-shadow: -8px 10px 40px rgba(1, 118, 255, 15%);
    text-align: center;
  }

  .step-title {
    padding: 30px;
    line-height: 40px;
    text-align: left;
    font-weight: 600;
    font-size: 40px;
    color: #2e2c51;

    span {
      color: #0d7cff;
    }
  }

  .steps-info {
    margin-top: 18px;
    width: 578px;
    height: 113px;
  }

  button {
    margin: 32px;
    width: 638px;
    height: 96px;
    box-shadow: 0 8px 24px rgba(84, 118, 244, 40%);
  }
}
</style>
